// Handles uploading different image types (regimen pic, product pic, etc.) @todo16 need to also support uploading additional pics for product, regimen steps, etc.
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { uploadProfilePic } from '../../actions/profile';
import { uploadProductPic } from '../../actions/product';
import { uploadRegimenPic, uploadRegimenStepPic } from '../../actions/regimen';
import { setAlert } from '../../actions/alert';

export const ImgTypeEnum = {
    PROFILE: 1,
    PRODUCT: 2,
    REGIMEN: 3,
    REGIMENSTEP: 4,
};

// path: where in bucket to save it. e.g. /products/productid
const FileUpload = ({
    formID,
    id, // passed in for calls that update a particular obj id
    stepid, // passed in for regimen steps
    uploadType,
    allowVideo,
    uploadProfilePic,
    uploadProductPic,
    uploadRegimenPic,
    uploadRegimenStepPic,
    setAlert,
}) => {
    const [files, setFiles] = useState('');

    const submitFiles = (e) => {
        e.preventDefault(); // don't let browser do its default behavior

        if (!files || files.length === 0) {
            setAlert('Please select a photo to upload', 'danger');
            return;
        }

        let file = files[0];

        // // check file size on client to avoid 413 error from server
        // const maxsz = 3145728; // 3mb
        // if (file.size > maxsz) {
        //     setAlert('Maximum file size is 3 MB.', 'danger');
        //     return;
        // }

        const formData = new FormData();
        formData.append('file', file);

        if (uploadType === ImgTypeEnum.PROFILE) {
            uploadProfilePic(formData);
        } else if (uploadType === ImgTypeEnum.PRODUCT) {
            uploadProductPic(formData, id);
        } else if (uploadType === ImgTypeEnum.REGIMEN) {
            uploadRegimenPic(formData, id);
        } else if (uploadType === ImgTypeEnum.REGIMENSTEP) {
            uploadRegimenStepPic(formData, id, stepid);
        } else {
            // error
            setAlert(
                'Server error: Invalid upload type specified. Please contact us to resolve.',
                'danger'
            );
            return;
        }

        //document.querySelector('#uploadform-' + formID).reset(); // for form, but no longer using form
    };

    const getAllowedFileTypes = () => {
        let imgs = 'image/jpg,image/png,image/gif';
        return allowVideo ? imgs + ',video/mp4' : imgs;
    };

    return (
        <div className='form' id={'uploadform-' + formID}>
            <div className='upload-actions'>
                <input
                    type='file'
                    accept={getAllowedFileTypes()}
                    onChange={(e) => setFiles(e.target.files)}
                />
                <button
                    className='btn btn-primary mr-0'
                    onClick={(e) => submitFiles(e)}
                >
                    Upload
                </button>
            </div>
        </div>
    );
};

FileUpload.propTypes = {
    formID: PropTypes.string.isRequired,
    id: PropTypes.string,
    stepid: PropTypes.string,
    uploadProfilePic: PropTypes.func.isRequired,
    uploadProductPic: PropTypes.func.isRequired,
    uploadRegimenPic: PropTypes.func.isRequired,
    uploadRegimenStepPic: PropTypes.func.isRequired,
    setAlert: PropTypes.func.isRequired,
    uploadType: PropTypes.number.isRequired,
};

FileUpload.defaultProps = {
    allowVideo: false,
};

export default connect(null, {
    uploadProfilePic,
    uploadProductPic,
    uploadRegimenPic,
    uploadRegimenStepPic,
    setAlert,
})(FileUpload);
